import "reflect-metadata";

import "assets/css/reset.css";
import "assets/css/fonts.css";
import "assets/css/core.css";

import {BrowserTracing, Integrations, Replay, init} from "@sentry/react";
import {BASE_URL, SENTRY_ALLOW_URLS, SENTRY_DSN_URL} from "data/constants";
import {
	DIContainer,
	controllers,
	providers,
	services,
	stores,
} from "data/services/locator/locator_container.service";
import {InjectionProvider} from "data/services/locator/locator_provider.service";
import React, {Suspense} from "react";
import {createRoot} from "react-dom/client";
import {BrowserRouter} from "react-router-dom";
import {RootRoutes, SecretGateRoutes} from "routes";
import {CookieBanner} from "views/components/CookieBanner/cookie_banner.component";
import {Bootstrap} from "views/components/bootstrap/bootstrap.component";
import {MobileMenu} from "views/components/menu/menu.component";
import {PagePreloader} from "views/components/preloader";
import {Session} from "views/components/session/session.component";
import {MainWrapper} from "views/components/style";
import {SecretGateController} from "views/controllers/secrete_gate/secret_gate.controller";
import reportWebVitals from "./reportWebVitals";
import {Modals} from "views/components/modals";

if (SENTRY_DSN_URL) {
	init({
		dsn: SENTRY_DSN_URL,
		integrations: [
			new BrowserTracing(),
			new Replay(),
			new Integrations.Breadcrumbs({
				console: false,
			}),
		],
		environment: process.env.REACT_APP_SENTRY_ENV || "development",
		allowUrls: SENTRY_ALLOW_URLS,
		denyUrls: [
			"quantcast",
			"xsca",
			// browser's extensions
			/extensions\//i,
			/^chrome:\/\//i,
			/^moz-extension:\/\//i,
		],
		ignoreErrors: [
			"Abort due to cancellation of share",
			"AbortError: Share canceled",
			"Can't find variable: _AutofillCallbackHandler", //Instagram browser issue
		],
		sampleRate: 0.1,
	});
}

const root = document.getElementById("root");

if (!root) {
	throw Error("Root element was not found");
}

DIContainer.load(services, providers, stores, controllers);

createRoot(root).render(
	<React.StrictMode>
		<InjectionProvider container={DIContainer}>
			<Bootstrap>
				<BrowserRouter basename={BASE_URL}>
					<Suspense fallback={<PagePreloader />}>
						<MainWrapper>
							{SecretGateController.IS_SECRET_PASSED ? (
								<>
									<Session>
										<RootRoutes />
									</Session>
									<MobileMenu />
									<Modals />
								</>
							) : (
								<SecretGateRoutes />
							)}
							<CookieBanner />
						</MainWrapper>
					</Suspense>
				</BrowserRouter>
			</Bootstrap>
		</InjectionProvider>
	</React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
